import signupReducer from "./signupReducer";

export const signupReducers = {
  signup: signupReducer,
};
